export function learningCatalogQuery(search, defaultScope = 'assigned') {
  const source = new URLSearchParams(search);
  const query = new URLSearchParams({ scope: source.get('scope') || defaultScope, limit: '24' });
  for (const name of ['search', 'type', 'status', 'category', 'tag', 'locale', 'instructor', 'progress', 'cursor']) {
    if (source.get(name)) query.set(name, source.get(name));
  }
  return query;
}

export function learningCatalogPageQuery(query, cursor = null) {
  const result = new URLSearchParams(query);
  if (cursor) result.set('cursor', String(cursor)); else result.delete('cursor');
  return result;
}
